
    document.addEventListener('DOMContentLoaded', function() {
        // Select the input field by its ID
        var inputField = document.getElementById('47574-text-2');

        // Check if the input field exists before setting placeholder
        if (inputField) {
            inputField.placeholder = 'https://www.therealautograph.com/pages/contact-us';
        } else {
            console.error('Input field with ID "contact-us-url-input" not found.');
        }
    });




document.addEventListener('DOMContentLoaded', function() {
   setTimeout(function() {
      if (document.body.classList.contains('account')) {
          document.body.classList.remove('account');
      }
  }, 10);
   setTimeout(function() {
      if (document.body.classList.contains('addresses')) {
          document.body.classList.remove('addresses');
      }
  }, 10);
});


$(document).ready(function(){
    $(".home.banner-carousel-slider").owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: true
    });
  });


// slider previous next script

$(document).ready(function() {
    var owl1 = $('.vimeo-video-section .home.banner-carousel-slider');
    owl1.owlCarousel();
    
    $('.left-arrow').click(function () {
        owl1.trigger('prev.owl.carousel');
    });
    
    $('.right-arrow').click(function () {
        owl1.trigger('next.owl.carousel');
    });
});


// collection
//mistrybanner-carousel-slider
$(document).ready(function(){
    $(".mistry.banner-carousel-slider").owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      nav: false,
      dots: false,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: false
    });
  });

// slider previous next script

$(document).ready(function() {
    var owl1 = $('.vimeo-video-section .mistry.banner-carousel-slider');
    owl1.owlCarousel();
    
    $('.left-arrow').click(function () {
        owl1.trigger('prev.owl.carousel');
    });
    
    $('.right-arrow').click(function () {
        owl1.trigger('next.owl.carousel');
    });
});



//globo filter add link show-more script.
$(document).on('click','.demo-test',function() {
    $(this).parent().find('.gf-block-scroll').css('max-height', '100%');
    $('.demo-test').hide();
});


// $(document).ready(function() {
//   alert('nhhdfh');
// $('.wizard__content').closest('div').find('p').css('color','');

// });


$( document ).ready(function() {
   setTimeout(function() {
      $('a[href^="https://globosoftware.net"]').css("display","none");
      $('a[href^="https://apps.shopify.com/form-builder-contact-form"]').parent().css("display","none");
     }, 1000);
});

